var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "16px",
    viewBox: "0 0 25 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Mastercard logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Limepay-Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "15.1-Payment-Modal-Validation",
    transform: "translate(-562.000000, -336.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Modal",
    transform: "translate(460.000000, 275.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cards",
    transform: "translate(45.000000, 55.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "img-fi-mastercard"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.501237, 0.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mastercard-logo",
    transform: "translate(10.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Clip-5",
    points: "0 18.8829759 23.9353408 18.8829759 23.9353408 8.33525387e-05 0 8.33525387e-05"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#FF5F00",
    points: "8.4074708 15.8458177 15.5280754 15.8458177 15.5280754 4.05018321 8.4074708 4.05018321"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 2.446189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.14250295,7.50170765 C9.14250295,5.10865626 10.2473216,2.97754023 11.967732,1.60389039 C10.7094264,0.599283915 9.12195583,-2.08381347e-05 7.39640864,-2.08381347e-05 C3.3114356,-2.08381347e-05 6.16413618e-05,3.35866971 6.16413618e-05,7.50170765 C6.16413618e-05,11.6447456 3.3114356,15.0034361 7.39640864,15.0034361 C9.12195583,15.0034361 10.7094264,14.4041314 11.967732,13.3995249 C10.2473216,12.0258751 9.14250295,9.89475903 9.14250295,7.50170765",
    id: "Fill-6",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7044528,12.2237748 L23.7044528,11.8591075 L23.6294558,11.8591075 L23.5431579,12.1099631 L23.4570655,11.8591075 L23.3820685,11.8591075 L23.3820685,12.2237748 L23.4348746,12.2237748 L23.4348746,11.9486428 L23.5158302,12.1859246 L23.570691,12.1859246 L23.6514412,11.9481208 L23.6514412,12.2237748 L23.7044528,12.2237748 Z M23.2296088,12.2237748 L23.2296088,11.9212341 L23.3257694,11.9212341 L23.3257694,11.8596295 L23.0812586,11.8596295 L23.0812586,11.9212341 L23.1772137,11.9212341 L23.1772137,12.2237748 L23.2296088,12.2237748 Z",
    id: "Fill-7",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9354024,7.50170765 C23.9354024,11.6447456 20.623823,15.0034361 16.5390554,15.0034361 C14.8135082,15.0034361 13.2258322,14.4041314 11.967732,13.3995249 C13.6881424,12.0258751 14.7929611,9.89475903 14.7929611,7.50170765 C14.7929611,5.10865626 13.6881424,2.97754023 11.967732,1.60389039 C13.2258322,0.599283915 14.8135082,-2.08381347e-05 16.5390554,-2.08381347e-05 C20.623823,-2.08381347e-05 23.9354024,3.35866971 23.9354024,7.50170765",
    id: "Fill-8",
    fill: "#F79E1B"
  })))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.f8984fce.svg";
export { ForwardRef as ReactComponent };